import { createApi, fetchBaseQuery, FetchBaseQueryError, retry } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'
import { EditTokenPayload, Token, TokenResponse } from 'types'

import { setTokenData } from 'store/reducers-common'
import { getSignature } from 'utils/getSignature'

const fetchBaseQueryWithRetry = retry(fetchBaseQuery({ baseUrl }), {
  maxRetries: 3,
})

export const queryDictionary = createApi({
  baseQuery: fetchBaseQueryWithRetry,
  endpoints: (builder) => ({
    editToken: builder.query<Token, { body: EditTokenPayload; id: string }>({
      queryFn: async (arg, _api, _extraOptions, baseQuery) => {
        const { body, id } = arg

        const { deadline, signature } = await getSignature({
          payload: body,
          primaryType: 'EditToken',
          url: apiPath.tokenEdit(id),
        })

        const result = await baseQuery({
          body,
          headers: { deadline: `${deadline}`, signature },
          method: 'POST',
          url: apiPath.tokenEdit(id),
        })
        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }
        return { data: result.data as Token }
      },
    }),
    getTokens: builder.query<TokenResponse, string | void>({
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setTokenData(data.data))
        } catch {
          // Consumers handle query errors through RTK Query.
        }
      },
      query: (params) => {
        const paramsUrl = params || ''
        return `${apiPath.token}${paramsUrl}`
      },
    }),
  }),
  reducerPath: 'dictionary',
})

export const { useGetTokensQuery, useLazyEditTokenQuery, useLazyGetTokensQuery } = queryDictionary
